import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IQuestion, AnswerDisplay, GroupType } from '@fgb/core';

@Component({
  selector: 'fgbcl-games-question-item',
  templateUrl: './games-question-item.component.html',
  styleUrls: ['./games-question-item.component.scss'],
})
export class GamesQuestionItemComponent {
  @Input() question: IQuestion;
  @Input() groupId: number;
  @Input() currentQuestionIndex: number;
  @Input() groupType: GroupType;
  @Output() answerSelected = new EventEmitter<any>();
  @Output() loadingState = new EventEmitter<boolean>();
  answerType = AnswerDisplay;
  correctAnswer: boolean;
  @Input() isExternal: boolean = false;

  onAnswerSelected(answer: any) {
    this.answerSelected.emit(answer);
  }

  getCorrectAnswer(): any {
    const randomIndex = Math.floor(Math.random() * this.question.Answers.length);
    return this.question.Answers[randomIndex];
  }
}
